// extracted by mini-css-extract-plugin
export var container = "_bi-0";
export var icon = "_bi-1";
export var text = "_bi-2";